import * as React from 'react'
import { useMemo } from 'react'
import { useClientCountWidget, useClientCountByDay } from './hooks'
import { Card, Statistic, Flex, Spin, Tooltip } from 'antd'
import { TeamOutlined } from '@ant-design/icons'
import { Column } from '@ant-design/plots'
import { path } from '../../../../libs'

export const ClientCountWidget = () => {
  const { clientCount, loading } = useClientCountWidget()
  const { clientCountByDay } = useClientCountByDay()

  const chartData = useMemo(() => {
    const days = Array.isArray(clientCountByDay) ? clientCountByDay : []
    return [...days]
      .sort(
        (a, b) =>
          new Date(a.txn_month.split(' ')[0]).getTime() -
          new Date(b.txn_month.split(' ')[0]).getTime(),
      )
      .map((d) => ({
        date: d.txn_month.split(' ')[0],
        users: d.user_count,
      }))
  }, [clientCountByDay])

  return (
    <Card size="small" style={{ flex: 1, minWidth: 320 }}>
      <Spin spinning={loading}>
        <Statistic
          title={
            <Flex align="center" gap={6}>
              <TeamOutlined style={{ color: '#3b82f6' }} />
              <Tooltip title="Общее количество клиентов. График — новые регистрации по месяцам.">
                <a target="_blank" href={path.clients.entry()} style={{ fontSize: 12, color: 'inherit' }}>
                  Users
                </a>
              </Tooltip>
            </Flex>
          }
          value={clientCount.count.toLocaleString('ru-RU')}
          valueStyle={{
            fontSize: 28,
            fontFamily: 'monospace',
            fontWeight: 600,
          }}
        />
        {chartData.length > 1 && (
          <div style={{ height: 180, marginTop: 12 }}>
            <Column
              data={chartData}
              xField="date"
              yField="users"
              height={180}
              style={{ fill: '#3b82f6' }}
              axis={{
                x: {
                  label: {
                    style: { fontSize: 10 },
                    autoRotate: true,
                    formatter: (v: string) => {
                      const d = new Date(v)
                      return d.toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' })
                    },
                  },
                },
                y: {
                  label: {
                    style: { fontSize: 10 },
                  },
                },
              }}
              legend={false}
              tooltip={(d: { date: string; users: number }) => ({
                name: 'Users',
                value: d.users,
              })}
            />
          </div>
        )}
      </Spin>
    </Card>
  )
}
